// Utilidades de los pines de localizacion 
import L from "leaflet";
import { getActiveShift } from './ShiftUtil'
import "leaflet.awesome-markers";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

export const greenIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

export const yellowIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

export const redIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

export const attendanceIcon = L.icon({
  iconUrl: '/pin-de-ubicacion_sm.png',
  markerColor: "blue",
  color: "blue",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32]
});

export const gosenIcon = L.icon({
  iconUrl: '/edificio-gosen.png',
  //markerColor: "blue",
  //color: "blue",
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32]
});

export const populateSiteData = (templates, attendances, shifts, sites, employees) => {
  const safeSites = Array.isArray(sites) ? sites : [];
  const safeShifts = Array.isArray(shifts) ? shifts : [];
  const safeAttendances = Array.isArray(attendances) ? attendances : [];
  const safeEmployees = Array.isArray(employees) ? employees : [];

  return safeSites.map(site => {
    const siteShifts = safeShifts.filter(shift => shift.siteId === site.id);
    const activeShift = getActiveShift(siteShifts, templates);
    const activeAttendance =
      activeShift
        ? safeAttendances.find(
          att => att.scheduledShiftId === activeShift.id
        )
        : null;
    const employee = activeShift ? safeEmployees.find(e => e.id === activeShift.employeeId) : null;
    return {
      siteId: site.id,
      attendance: activeAttendance,
      shift: activeShift,
      status: activeAttendance?.attendanceStatus ?? "NO_SHOW",
      employee: employee
    };
  });
};

export const getSiteDataForSite = (siteId, siteData) => {
  if (!Array.isArray(siteData) || siteData.length === 0) return null;
  return siteData.find(data => data.siteId === siteId) ?? null;
};

export const getIconByEnrichedSite = (enrichedSite) => {
  if (!enrichedSite || !enrichedSite.attendance) return redIcon;
  const status = enrichedSite.attendance?.attendanceStatus;
  if (status === "ON_TIME") return greenIcon;
  if (status === "LATE" || status === "LEFT_EARLY") return yellowIcon;
  return redIcon;
};

export const getAttendanceIcon = (attendance) => {
  return attendanceIcon;
};

export const getGosenIcon = () => {
  return gosenIcon;
};  